import { createRequest, getEndpoint } from "../requestCreator";

export const getReportTemplates = createRequest(getEndpoint("reportTemplates.sub.get"));
